import { render, staticRenderFns } from "./VacationCarryOverApproverList.vue?vue&type=template&id=150d5678&"
import script from "./VacationCarryOverApproverList.vue?vue&type=script&lang=ts&"
export * from "./VacationCarryOverApproverList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports